import Divider from '@material-ui/core/Divider';
import clsx from 'clsx';
import {useModal} from 'packages/hooks/use-modal';
import {CustomTab, CustomTabs} from 'packages/common-ui/CustomTabs';
import {ChangeEvent, FC, useState} from 'react';
import TabPanel from 'packages/common-ui/TabPanel';
import useCommonStyles from 'packages/common-utils/common-styles';
import NewTournament from 'packages/dialogs/new-tournament/NewTournament';
import useStyles from '../admin-styles';
import Groups from '../groups/Groups';
import TournamentsTable from './Table';
import RegisteredPlayers from './RegisteredPlayers';

const Tournaments: FC = () => {
  const classes = useStyles();
  const common = useCommonStyles();
  const [selectedTab, setSelectedTab] = useState(0);
  const {toggle: toggleCreateTournament, modalOpen} = useModal({
    initialMode: false,
  });
  const handleOnChangeTab = (_: ChangeEvent<{}>, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <NewTournament modalOpen={modalOpen} toggle={toggleCreateTournament} />
      <div
        className={clsx([
          common.default_padding,
          common.gray_background,
          classes.tr_root,
        ])}
      >
        <div>
          <CustomTabs value={selectedTab} onChange={handleOnChangeTab}>
            <CustomTab
              label="Lista de torneos"
              id="simple-tab-1"
              aria-controls="simple-tabpanel-1"
            />
            <CustomTab
              label="Grupos formados"
              id="simple-tab-2"
              aria-controls="simple-tabpanel-2"
            />
            <CustomTab
              label="Jugadores por torneo"
              id="simple-tab-2"
              aria-controls="simple-tabpanel-2"
            />
          </CustomTabs>
          <Divider />
          <TabPanel value={selectedTab} index={0}>
            <TournamentsTable />
          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            <Groups />
          </TabPanel>
          <TabPanel value={selectedTab} index={2}>
            <RegisteredPlayers />
          </TabPanel>
        </div>
      </div>
    </>
  );
};

export default Tournaments;
